export const config = {
    //Contains various config options for the two different environments the solution will be ran in
    
    dev: {
        appName: '/',
        baseUrl: 'https://localhost:7093',        
        //Timeout value(in milliseconds) for calls from the http service to the
        //backend API
        httpApiServiceTimeOut: 3000000,
        //If JWT Token expires, attempt to refresh? -- only for JWT Bearer Authentication
        attemptTokenRefresh: true,
        version: '1.0.26'
    },
    build: {
        appName: '/',
        baseUrl:'https://rtxintegrationhub.kellars.co.uk',
        // Time out value (in milliseconds) for calls from the http service to
        // the backend API
        httpApiServiceTimeOut: 300000,
        // Attempt to refresh JWT token if expired - JWT Bearer Authentication
        attemptTokenRefresh: true,
        version: '1.0.26'
    }

}
